import React from "react"
import { Main, Wrapper, TextBox } from "./style"
import image1 from "../../../images/aboutus-image1.jpg"
import image2 from "../../../images/aboutus-image2.jpg"
import { renderRichText } from "gatsby-source-contentful/rich-text"

const FirstSection = ({ field1, field2 }) => {
  return (
    <Main>
      <Wrapper imageFirst={false}>
        <TextBox imageFirst={false}>{field1 && renderRichText(field1)}</TextBox>
        <img src={image1} alt="zdjęcie" />
      </Wrapper>

      <Wrapper imageFirst={true}>
        <TextBox imageFirst={true}>{field2 && renderRichText(field2)}</TextBox>
        <img src={image2} alt="zdjęcie" />
      </Wrapper>
    </Main>
  )
}

export default FirstSection
